
// Define supported environment presets
const ENV_PRESETS = {
  local: {
    API_BASE: 'http://localhost:4001',
    APP_BASE: 'http://localhost:7000',
    AI_API_BASE: 'http://localhost:5001',
    WWW_BASE: 'https://idearify.com',
  },
  production: {
    API_BASE: 'https://api.idearify.com',
    APP_BASE: 'https://app.idearify.com',
    AI_API_BASE: 'https://ai.idearify.com',
    WWW_BASE: 'https://idearify.com',
  },
} as const;

// 2. Determine target mode:
//    - Read from `.env` flag `VITE_APP_ENV` ('local' | 'staging' | 'production')
//    - Or fall back to Vite's built-in `import.meta.env.MODE` ('development' / 'production')
type EnvMode = keyof typeof ENV_PRESETS;

const TARGET_ENV: EnvMode =
  (import.meta.env.VITE_APP_ENV as EnvMode) ||
  (import.meta.env.DEV ? 'local' : 'production');

const currentPreset = ENV_PRESETS[TARGET_ENV] || ENV_PRESETS.production;

// 3. Export configuration with individual .env overrides if explicitly provided
export const API_BASE = import.meta.env.VITE_API_BASE || currentPreset.API_BASE;
export const APP_BASE = import.meta.env.VITE_APP_BASE || currentPreset.APP_BASE;
export const AI_API_BASE = import.meta.env.VITE_AI_API_BASE || currentPreset.AI_API_BASE;
export const WWW_BASE = import.meta.env.VITE_WWW_BASE || currentPreset.WWW_BASE;
export const VITE_STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const REQUEST_TIMEOUT = 30000; // 30 seconds